






































































































































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { PaymentMethod, PaymentSource } from '@/Payment/Enums';
import Vue from 'vue';
import VatsAPI from '@/Shared/VatsAPI';
import { HostedCheckoutRequest } from '@/Payment/HostedCheckoutRequest';
import { Dictionary } from 'vue-router/types/router';
import axios, { AxiosResponse } from 'axios';
import { PaymentResult } from '@/Payment/PaymentResult';
import { PaymentProfile } from '@/Permit/Payment/PaymentProfile';
import Permit from '../Permit';
import { getPaymentMethodComponent } from '@/Payment/PaymentMethods/GetPaymentMethodComponent';
import { User } from '@/Stores/UserStore';
import PaymentMethods from '@/Payment/PaymentMethods/PaymentMethods.vue';
import PaymentCompletion from '@/Payment/PaymentCompletion.vue';
import PermitCustomer from '../PermitCustomer';
import { CustomerRequiredFields } from '@/Customer/CustomerRequiredFields';
import { PermitRequestStatus } from '../Enum';
import I18nMixin from '@/Shared/I18nMixin';
import UserMixin from '@/Shared/UserMixin';


const externalCustomerRequiredFields: Partial<CustomerRequiredFields> = {
    emailAddress: true,
};

const internalCustomerRequiredFields: Partial<CustomerRequiredFields> = {
    firstName: false,
    lastName: false,
    address1: false,
    address2: false,
    city: false,
    state: false,
    zip: false,
    phoneNumber: false,
    emailAddress: false,
};

const PermitPayment = mixins(I18nMixin, LocationBasedMixin, UserMixin).extend({
  name: 'PermitPayment',
  props: {
    permitID: {
      required: true,
      type: String
    },
    location: {
      required: true,
      type: ('' as any) as () => string
    }
  },
  components: {
    PaymentMethods,
    PaymentCompletion,
    CustomerEdit: () => import('@/Customer/CustomerEdit.vue'),
  },
  async beforeMount() {
    if (this.permitID) {
      await this.searchPermit(this.permitID);
    }
    else {
      this.customer = new PermitCustomer();
    }
  },
  data() {
    return {
      loadingPermit: false,
      refreshingProfile: false,
      profile: { permit: {} as Permit } as PaymentProfile,
      paymentProcessing: false,
      PaymentMethod,
      paymentMethodDisplay: Object.keys(PaymentMethod),
      selectedPaymentMethod: PaymentMethod.Card as PaymentMethod | null,
      PaymentSource,
      paymentSourceDisplay: Object.keys(PaymentSource),
      selectedPaymentSource: null as PaymentSource | null,
      result: null as PaymentResult | null,
      customer: null as PermitCustomer | null,
      customerErrors: null as Dictionary<string[]> | null,
      canRenew: false
    };
  },
  computed: {
    canSelectPaymentMethod(): boolean {
        return this.selectedPaymentSource !== PaymentSource.CallIn;
    },
    i18nPrefix(): string { return  'payment.permitPayment'; },
    payableQueryUrl(): string {
        return `${this.location}/PermitPayments/${this.selectedPaymentMethod}/payable${this.isInternal ? 'Internal' : ''}`;
    },
    selectedPaymentSubtotal(): number {
      const subtotal = this.profile.balanceDue - this.profile.discount;

      return subtotal;
    },
    selectedPaymentTotal(): number {
        return this.selectedPaymentSubtotal + this.profile.fee;
    },
    permitIDsToPay(): number[] {
      return [this.profile.permit.recID];
    },
    customerRequiredFields(): Partial<CustomerRequiredFields> {
        return (this.isInternal) ? internalCustomerRequiredFields : externalCustomerRequiredFields;
    },
    blockPayment(): boolean {
        return !!this.profile.blocked && !this.permitAlreadyPaid;
    },
    permitAlreadyPaid(): boolean {
      return (this.permitPending || this.permitActive) && !this.canRenew;
    },
    permitPending(): boolean {
      return this.profile?.permit?.requestStatus === PermitRequestStatus.PENDING;
    },
    permitActive(): boolean {
      return this.profile?.permit?.requestStatus === PermitRequestStatus.ACTIVE;
    },
    noBalanceDue(): boolean {
      return this.profile.balanceDue === 0;
    },
    loading(): boolean {
      return this.refreshingProfile || this.loadingPermit;
    }
  },
  watch: {
    async permit() {
      await this.searchPermit();
    }
  },
  methods: {
    async checkRenewable(permitID: string) {
      return await (await VatsAPI.get<boolean>(
        `/${this.location}/Permits/renewable`,
        { params: { recID: permitID }})).data;
    },
    async searchPermit(permitID: string = '') {
      // todo:permit don't let them pay for one that is already paid for
      this.loadingPermit = true;
      this.result = null;

      try {
        const response = await VatsAPI.get<PaymentProfile>(this.payableQueryUrl, {
          params: {
            recID: permitID,
            paymentSource: this.selectedPaymentSource || PaymentSource.Online
          }
        });

        this.profile = response.data;

        this.customer = this.profile.customer || new PermitCustomer();

        this.canRenew = await this.checkRenewable(permitID);
      }
      catch (e) {
        const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.loadFailedTitle`);
        const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.loadFailedMessage`);
        this.$bvToast.toast(translatedMessage.toString(), {
            title: translatedTitle.toString(),
            autoHideDelay: 5000
        });
        throw e;
      }
      finally {
        this.loadingPermit = false;
      }
    },
    async refreshPaymentProfile() {
      if (this.selectedPaymentSource === PaymentSource.CallIn) {
          this.selectedPaymentMethod = PaymentMethod.Card;
      }

      if (this.selectedPaymentMethod && this.selectedPaymentSource) {
        this.refreshingProfile = true;
        try {
            const url = `${this.location}/PermitPayments/${this.selectedPaymentMethod}/FeeAndDiscount`;
            const result = await VatsAPI.get<{ item1: number, item2: number }>(url, {
                params: {
                    paymentSource: this.selectedPaymentSource
                }
            });

            const { item1, item2 } = result.data;
            this.profile.fee = item1;
            this.profile.discount = item2;
        }
        catch (e) {
            // TODO
        }
        finally {
            this.refreshingProfile = false;
        }
      }
    },
    paymentSubmitting() {
      this.loadingPermit = true;
    },
    async paymentSucceeded(result: PaymentResult) {
      this.result = result;

      if (result.hostedCheckoutRequest) {
        return;
      }

      if (!this.result.success) {
        return;
      }

      this.reset();
    },
    reset() {
      this.loadingPermit = false;
      this.profile = { permit: {} as Permit } as PaymentProfile;
      this.selectedPaymentMethod = null;
      this.selectedPaymentSource = null;
    },
    paymentFailed(e: any) {
      this.loadingPermit = false;
      this.paymentProcessing = false;
    },
    paymentErrored(e: any) {
      this.paymentProcessing = false;
      this.loadingPermit = false;

      const translatedTitle = this.$i18n.t(`${this.i18nPrefix}.paymentFailedTitle`);
      const translatedMessage = this.$i18n.t(`${this.i18nPrefix}.paymentFailedMessage`);
      this.$bvToast.toast(translatedMessage.toString(), {
          title: translatedTitle.toString(),
          autoHideDelay: 5000
      });

      this.customerErrors = Object.keys(e.response.data.errors)
          .filter(item => item.split('.')[0] === 'Customer')
          .reduce((errorObj, key) => {
              const errorList = e.response.data.errors[key];
              const propName = key.split('.')[1];
              errorObj[propName] = errorList;
              return errorObj;
          }, {} as Dictionary<string[]>);

      throw e;
    },
    locationChanged() {
        this.searchPermit();
    }
  }
});

export default PermitPayment;
